import { SrIcon } from "@/components/ui/SrIcon";
import type { ChatSummary } from "@/hooks/use-chat-summary";

interface ChatSummaryCardProps {
  unread: number;
  sinceLabel: string;
  isLoading: boolean;
  error: string | null;
  summary: ChatSummary | null;
  onClose: () => void;
}

/** AI-oppsummeringen over meldingene (VIB-3027): punkter og det som venter på deg. */
export function ChatSummaryCard({ unread, sinceLabel, isLoading, error, summary, onClose }: ChatSummaryCardProps) {
  return (
    <section
      aria-label="AI-oppsummering"
      className="mx-5 mt-4 flex flex-col gap-2 rounded-[10px] border-[1.5px] border-primary bg-primary/[0.07] px-4 py-3.5 text-sm leading-relaxed"
    >
      <div className="flex items-center gap-2">
        <span className="text-[11px] font-semibold uppercase tracking-[0.08em] text-primary">AI-oppsummering</span>
        <span className="text-xs text-muted-foreground">
          {unread} {unread === 1 ? "ulest" : "uleste"} siden {sinceLabel}
        </span>
        <button
          type="button"
          onClick={onClose}
          aria-label="Lukk oppsummering"
          className="ml-auto flex h-7 w-7 items-center justify-center rounded-md hover:bg-primary/10"
        >
          <SrIcon name="x" className="h-3.5 w-3.5" />
        </button>
      </div>
      {isLoading && (
        <p role="status" className="flex items-center gap-2 text-muted-foreground">
          <SrIcon name="loader2" className="h-3.5 w-3.5 animate-spin" />
          Leser {unread} {unread === 1 ? "ulest melding" : "uleste meldinger"} …
        </p>
      )}
      {error && <p className="text-destructive">{error}</p>}
      {summary && (
        <>
          <ul className="list-disc space-y-0.5 pl-5">
            {summary.points.map((p) => (
              <li key={p}>{p}</li>
            ))}
          </ul>
          <p className="mt-1 font-semibold">Til deg</p>
          {summary.forYou.length > 0 ? (
            <ul className="list-disc space-y-0.5 pl-5">
              {summary.forYou.map((p) => (
                <li key={p}>{p}</li>
              ))}
            </ul>
          ) : (
            <p className="text-muted-foreground">Ingenting her venter på svar fra deg.</p>
          )}
        </>
      )}
    </section>
  );
}
